import { useState } from 'react'
import CampusMap from './components/Campus/index'
import styled from 'styled-components'
import Theme from '../../Theme'
import Grid from './assets/grid.svg'
import Popup from './components/Popup'
import View360 from './components/View3D'
import Welcome from './components/Welcome'
import Logo from '../../components/core/Logo'
import { MenuToggle, NavBar } from '../../components/core'
import Locations from '../Menus/Locations/LocationsMenu'
import campus from '../../assets/campus.svg'

const Container = styled.div`
    background-color:${Theme.colors.BrandBlue};
    background-image:url(${Grid});
    position:relative;
    height:${window.innerHeight}px;
    width:100vw;
`
const MapWrapper = styled.div<{ focused: boolean }>`
    position:absolute;
    top:0;
    right: ${({ focused }) => !focused ? '50%' : '0%'};
    width: ${({ focused }) => !focused ? '50vw' : '78vw'};
    height:91vh;
    transition: all 1000ms ease-in-out;
`
const BackButtonWrapper = styled.div`
    position:absolute;
    top: 0px;
    left: 2px;
    padding: 20px;
    z-index: 11;
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      left:20px;
    }
`
const MenuIconContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 15;
  padding: 15px;
  cursor: pointer;
`

const Campus = styled.img`
    position: absolute;
    right: 20px;
    bottom: 20px;

    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      transform: rotate(-30deg)
    }

    @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
    bottom: 60px;
      transform: rotate(-30deg)
    }
`

type Props = {
    changeScreen: () => void
    backToSplit: any
    focused: boolean
}
export default function Map({ changeScreen, focused, backToSplit, }: Props) {
    const [location, setLocation] = useState(null as null | string)
    const [view3D, setView3D] = useState(false)
    const [heading, setHeading] = useState('')
    const [hotspotPosition, setHotspotPosition] = useState({})
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMenuClick = () => {
        setMenuOpen(prev => !prev);
    }
    const handleNavBarClick = () => {
        setMenuOpen(false);
        changeScreen()
    }
    const handleLocationClick = (location: string) => {
        setMenuOpen(false)
        setLocation(location)
    }
    return (
        <Container>
            {
                !!focused && !location &&
                <Welcome
                    hotspotPosition={hotspotPosition}
                    heading={heading ? heading : 'WELCOME TO LiUNA LOCAL 183 INTERACTIVE MAP'}
                    body={heading ? '' : 'Explore our training centre on your own. Click our various hotspots to learn more about each facility and its associated program.'}
                />
            }
            {
                view3D && !!location
                    ? <>
                        <View360 setView3D={setView3D} backToSplit={backToSplit} changeScreen={changeScreen} location={location} setLocation={setLocation} />
                    </>
                    :
                    <>
                        {
                            !menuOpen && focused &&
                            <a href='https://www.liuna.org/' target="_blank" >
                                <Logo position="right" />
                            </a>
                        }
                        {

                            focused && <NavBar backToSplit={backToSplit} onClick={handleNavBarClick} text='TAKE THE VIRTUAL TOUR' position={'left'} />
                        }


                        <MapWrapper focused={focused}>
                            <CampusMap
                                setHeading={setHeading}
                                setHotspotPosition={setHotspotPosition}
                                selectedLocation={location} setLocation={setLocation} />
                        </MapWrapper>
                        {
                            !!location &&
                            <Popup
                                closePopup={() => setLocation(null)}
                                location={location}
                                view3D={() => setView3D(true)}
                            />
                        }

                        <MenuIconContainer onClick={handleMenuClick}>
                            <MenuToggle open={menuOpen} />
                        </MenuIconContainer>

                        {menuOpen && <Locations close={handleMenuClick} selectLocation={handleLocationClick} />}



                    </>
            }

            { !view3D && <Campus src={campus} />}
        </Container>
    )
}